<template>
	<div class="email">
		<input
			class="mb_10"
			type="text"
			:placeholder="$t('merchant.security.placeholder')"
			:value="selectedAccountInfo?.address"
		/>
		<button class="button_bg_red mb_20" @click="sendVerificationCode">
			{{ $t('button.code') }}
		</button>
		<div v-if="token">
			<div class="d_flex mb_10">
				<input
					type="text"
					:placeholder="$t('merchant.security.placeholder1')"
					style="border-radius: 8px 0px 0px 8px; border-right: 0"
				/>
				<div class="timer">{{ time }}</div>
			</div>
			<div class="mb_15">
				<span class="fc_red_border" @click="sendVerificationCode">{{
					$t('merchant.email.link1')
				}}</span>
			</div>
			<button class="button_bg_red mb_30" @click="checkVerificationCode">
				{{ $t('button.code_check') }}
			</button>
			<!-- <button class="button_bg_black mb_60">
				{{ $t('button.code_completed') }}
			</button> -->
		</div>

		<!-- <div class="limit gray_back">
			<p class="mb_20">{{ $t('merchant.security.title3') }}</p>
			<ul>
				<li>- {{ $t('merchant.security.text1') }}</li>
				<li>- {{ $t('merchant.security.text2') }}</li>
				<li>- {{ $t('merchant.security.text3') }}</li>
				<li>- {{ $t('merchant.security.text4') }}</li>
			</ul>
		</div> -->

		<!-- <div v-if="!mobile">
			<div v-if="!token">
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					:value="member_info.email_address"
					disabled
				/>
				<button class="button_bg_red mt_10" @click="sendVerificationCode">
					{{ $t('button.code') }}
				</button>
			</div>

			<div v-if="token" class="mt_20">
				<div class="d_flex">
					<div class="timer">{{ time }}</div>
					<input
						type="text"
						:placeholder="$t('input.placeholder.code_request')"
						style="border-radius: 0 5px 5px 0"
					/>
				</div>
				<div class="link_code_send">
					<a class="fc_red" @click="sendVerificationCode">{{
						$t('merchant.email.link1')
					}}</a>
				</div>
				<button class="button_bg_red" @click="checkVerificationCode">
					{{ $t('button.code_check') }}
				</button>
			</div>
		</div>
		<div v-else class="mobile">
			<div v-if="!token">
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					:value="member_info.email_address"
					disabled
				/>
				<button class="button_bg_red w100 mt_10" @click="sendVerificationCode">
					{{ $t('button.code') }}
				</button>
			</div>
			<div v-if="token" class="mt_20">
				<div class="base">
					<span class="mobile_timer">{{ time }}</span>
					<input
						type="text"
						:placeholder="$t('input.placeholder.code_request')"
					/>
				</div>
				<div class="link_code_send">
					<a class="resend" @click="sendVerificationCode">{{
						$t('merchant.email.link1')
					}}</a>
				</div>
				<button class="button_bg_red" @click="checkVerificationCode">
					{{ $t('button.code_check') }}
				</button>
			</div>
		</div> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createVerification, createVerificationToken } from '@/api/mail';
import { commonError } from '@/common/dialog';
import { isMobile } from '@/common/mobile';

export default {
	name: 'Email',
	data() {
		return {
			token: null,
			timer: null,
			time: '05:00',
			time_remaining: 0,
			mobile: isMobile(),
		};
	},
	computed: {
		...mapGetters('auth', ['member_info']),
	},
	methods: {
		async sendVerificationCode() {
			const { token } = await createVerificationToken().catch(commonError);
			this.token = token;
			this.startTimer();
		},
		async checkVerificationCode() {
			const { token } = await createVerification({ token: token }).catch(
				commonError,
			);
			this.resetTimer();
		},
		startTimer() {
			clearInterval(this.timer);
			this.time_remaining = 300;
			this.timer = setInterval(() => {
				this.updateTimer();
			}, 1000);
		},
		resetTimer() {
			clearInterval(this.timer);
			this.token = null;
			this.time = '05:00';
		},
		updateTimer() {
			if (this.time_remaining === 0) return this.resetTimer();
			this.time_remaining--;
			const minute = '0' + Math.floor(this.time_remaining / 60);
			const seconds =
				this.time_remaining % 60 < 10
					? '0' + (this.time_remaining % 60)
					: this.time_remaining % 60;
			this.time = minute + ':' + seconds;
		},
	},
};
</script>
<style>
.rtr_mypage-certification .display_status {
	display: inline-block;
	padding: 10px 15px;
	min-width: 89px;
	font-size: 14px;
	color: #ccc;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 10px;
	pointer-events: none;
}
.rtr_mypage-certification .completed {
	color: #333;
	border-color: #333;
}
/* .rtr_mypage-certification .security_email .level_3 .icon {
	width: 31px;
	height: 17px;
	background-image: url('~@/assets/images/icon/otp.png');
	background-repeat: no-repeat;
}
.rtr_mypage-certification .security_email .level_4 .icon {
	height: 25px;
	width: 25px;
	background-image: url('~@/assets/images/icon/accout_security.png');
}
.rtr_mypage-certification .security_email .level_4 .circle_url {
	background: url('~@/assets/images/icon/four_gray.png');
	background-size: cover;
}
.level_4.on .rtr_mypage-certification .security_email .level_4 .icon {
	background-image: url('~@/assets/images/icon/accout_security_red.png') !important;
} */
.fc_red_border {
	position: relative;
	color: #ca0000;
	font-size: 14px;
}
.fc_red_border:before {
	content: '';
	position: absolute;
	bottom: -3px;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #ca0000;
}
</style>
